import React from 'react';
import classnames from 'classnames';

import bemBlock from '@gik/core/utils/bemBlock';
import { Button, Heading } from '@gik/ui';
import { canUserEditPage } from '@gik/inkind-page/utils/inkindPagePermissions';
import { useUserStore } from '@gik/core/store/UserStore';
import { useInkind } from '@gik/api/inkinds/inkind';
import { inkindPageTourSelectors } from '@gik/inkind-page/components/InkindPageTour/InkindPageTour';

const blockName = 'inkind-page-wishlist-header';

export interface IwishlistHeaderProps {
  inkindRouteId: string;
  className?: string;
}

function WishlistHeader({ inkindRouteId, className }: IwishlistHeaderProps): JSX.Element {
  const { data: inkindPage } = useInkind(inkindRouteId);
  const userStore = useUserStore();
  const userId = userStore.id;

  const giftingUrl = inkindPage?.inkindSituations.length > 0 && inkindPage.inkindSituations[0].giftingUrl;
  const canEdit = canUserEditPage(inkindPage, userId);

  const bem = bemBlock(blockName);
  const classNames = classnames([bem(), className]);

  // TODO: add translations
  return (
    <div className={classNames}>
      <Heading level={2} className={bem('wishlist-title')}>
        Wishlist
      </Heading>
      {canEdit && (
        <Button
          id={inkindPageTourSelectors.addItemsWishlist}
          disabled={!giftingUrl}
          variant="secondary"
          href={giftingUrl || '#'}
        >
          Add Items
        </Button>
      )}
    </div>
  );
}

export default WishlistHeader;
